import { GetApiData } from "utils/http-client";

export const CreateExercise = async (data) => {
  return await GetApiData(`/exercise`, "POST", data, true);
};

export const generateExercise = async (data) => {
  return await GetApiData(`/exercise/ai`, "POST", data, true);
};

export const generateListeningExercise = async (data) => {
  return await GetApiData(
    `/exercise/ai/generate/listening`,
    "POST",
    data,
    true
  );
};

export const finalizeListeningExercise = async (data) => {
  return await GetApiData(
    `/exercise/ai/finalGenerate/finalize-listening`,
    "POST",
    data,
    true
  );
};

export const generateWritingExercise = async (data) => {
  return await GetApiData(`/exercise/ai/writing`, "POST", data, true);
};

export const getAllSubject = async () => {
  return await GetApiData(`/subject`, "GET", null, true);
};
export const previewVoiceModel = async (data) => {
  return await GetApiData(`/exercise/ai/voice-preview`, "POST", data, true);
};
export const getExerciseById = async (id) => {
  return await GetApiData(`/exercise/${id}`, "GET", null, true);
};
export const updateWordInExercise = async (exerciseId, wordId, wordData) => {
  return await GetApiData(
    `/exercise/${exerciseId}/word/${wordId}`,
    "PUT",
    wordData,
    true
  );
};
export const removeWordFromExercise = async (exerciseId, wordId) => {
  return await GetApiData(
    `/exercise/${exerciseId}/word/${wordId}`,
    "DELETE",
    null,
    true
  );
};
export const addWordToExercise = async (exerciseId, wordData) => {
  return await GetApiData(
    `/exercise/${exerciseId}/word`,
    "POST",
    wordData,
    true
  );
};
export const getExerciseDifficulties = async (id) => {
  return await GetApiData(
    `/exercise/getalldifficulties/${id}`,
    "GET",
    null,
    true
  );
};
export const createExerciseQuestions = async (id, data) => {
  return await GetApiData(`/exercise/question/${id}`, "POST", data, true);
};
export const reportExercise = async (data) => {
  return await GetApiData(`/report`, "POST", data, true);
};
export const getAllReports = async (
  page = 1,
  search = "",
  contentType = "Exercise"
) => {
  return await GetApiData(
    `/report?page=${page}&contentType=${contentType}&search=${search}`,
    "GET",
    null,
    true
  );
};
export const getReportsByExercise = async (id) => {
  return await GetApiData(`/report/content/${id}`, "GET", null, true);
};
export const updateReportStatus = async (id, data) => {
  return await GetApiData(`/report/${id}`, "PUT", data, true);
};
export const updateExerciseQuestion = async (exerciseId, data) => {
  return await GetApiData(`/exercise/question/${exerciseId}`, "PUT", data, true);
};
export const deleteExerciseQuestions = async (exercise, id) => {
  return await GetApiData(
    `/exercise/question/${exercise}?question=${id}`,
    "DELETE",
    null,
    true
  );
};
export const updateExercise = async (id, data) => {
  return await GetApiData(`/exercise/${id}`, "PUT", data, true);
};
export const reorderQuestions = async (id, data) => {
  return await GetApiData(`/exercise/update/${id}`, "PATCH", data, true);
};
export const editTitle = async (id, data) => {
  return await GetApiData(`/exercise/editTitle/${id}`, "PATCH", data, true);
};
export const addTranslation = async (data) => {
  return await GetApiData(`/exercise/translate/add`, "POST", data, true);
};
export const generateDifficultyExercise = async (data) => {
  return await GetApiData(`/exercise/ai/difficulty`, "POST", data, true);
};

export const generateWrittingDifficultyExercise = async (data) => {
  return await GetApiData(
    `/exercise/ai/writtingdifficulty`,
    "POST",
    data,
    true
  );
};
export const getAllExercises = async (
  page = 1,
  subject = "",
  exercise = "",
  sort = "",
  search = "",
  libraryStatus = "",
  status = "",
  difficulty = "",
  isFavorite = false
) => {
  return await GetApiData(
    `/exercise/user?page=${page}&subject=${subject}&exerciseType=${exercise}&sort=${sort}&search=${search}&libraryStatus=${libraryStatus}&status=${status}&difficulty=${difficulty}&isFavorite=${isFavorite}`,
    "GET",
    null,
    true
  );
};
export const getFavouritesExercises = async (
  page,
  subject,
  exercise,
  sort,
  search,
  difficulty
) => {
  return await GetApiData(
    `/exercise/favourites?page=${page || 1}&subject=${
      subject || ""
    }&exerciseType=${exercise || ""}&sort=${sort || ""}&search=${
      search || ""
    }&difficulty=${difficulty || ""}`,
    "GET",
    null,
    true
  );
};
export const deleteExercises = async (id) => {
  return await GetApiData(`/exercise/${id}`, "DELETE", null, true);
};
export const removeFavouriteExercises = async (id) => {
  return await GetApiData(`/exercise/favourites/${id}`, "DELETE", null, true);
};
export const addToFavourites = async (id) => {
  return await GetApiData(`/exercise/favourites/${id}`, "POST", null, true);
};
export const addFavouriteExercises = async (id) => {
  return await GetApiData(`/exercise/favourites/${id}`, "POST", null, true);
};

export const translateExerciseAPI = async (data) => {
  return await GetApiData(`/exercise/translate`, "POST", data, true);
};

export const addToLibrary = async (id) => {
  return await GetApiData(`/exercise/library/request/${id}`, "PUT", null, true);
};
